// Click to copy: any element with `data-copy` copies that value, with a short "Copied" label above it.

/** A press that travels further than this was a drag (panel titles sit on the drag bar), not a click. */
const CLICK_SLOP_PX = 4;
const TIP_MS = 900;

let downX = 0;
let downY = 0;
let tip: HTMLDivElement | null = null;
let tipTimer: number | undefined;

export function installCopy(): void {
  document.addEventListener('pointerdown', (e) => { downX = e.clientX; downY = e.clientY; }, true);
  document.addEventListener('click', (e) => {
    const el = (e.target as HTMLElement | null)?.closest<HTMLElement>('[data-copy]');
    const value = el?.dataset.copy;
    if (!el || !value) return;
    if (Math.hypot(e.clientX - downX, e.clientY - downY) > CLICK_SLOP_PX) return;
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => show(el, 'Copied'), () => show(el, legacyCopy(value) ? 'Copied' : 'Copy failed'));
  }, true);
}

/** Fallback for when the async clipboard is refused: a selected off-screen textarea. */
function legacyCopy(value: string): boolean {
  const ta = document.createElement('textarea');
  ta.value = value;
  ta.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}

function show(el: HTMLElement, text: string): void {
  if (!tip) {
    tip = document.createElement('div');
    tip.className = 'copy-tip';
    document.body.appendChild(tip);
  }
  const r = el.getBoundingClientRect();
  tip.textContent = text;
  tip.style.left = `${r.left + Math.min(r.width, 160) / 2}px`;
  tip.style.top = `${r.top - 4}px`;
  tip.classList.add('on');
  clearTimeout(tipTimer);
  tipTimer = window.setTimeout(() => tip?.classList.remove('on'), TIP_MS);
}
